import { createSlice } from "@reduxjs/toolkit";
import Axios from "../../utils/axiosInstance";

const initialState = {
  chatList: [],
};

const slice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.chatList = [];
    },

    // CREATE CHAT
    createChat(state, action) {
      state.isLoading = false;
      state.chat = action.payload;
    },

    // GET
    getChatListSuccess(state, action) {
      state.isLoading = false;
      state.chatList = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow } = slice.actions;

// ----------------------------------------------------------------------

export function getChatList(id) {
  return async (dispatch) => {
    if (!id) return;

    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`/messages/${id}`);
      dispatch(slice.actions.getChatListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchNewChat(message) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.post("/messages", message);
      dispatch(slice.actions.createChat(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
